import React from 'react';
import usePromediosResultadosIngles from "../hooks/adminexamen/usePromediosResultadosIngles";
import { Toaster } from "react-hot-toast";

import { Button, Card, List, Select, Typography } from "antd";

const { Link } = Typography;

const PromediosResultadosIngles = () => {

    const { loading, carreras, promediosAspirantesIngles, promediosAspirantesInglesPorCarrera, promediosTodasCarreras,
    ciclo, ciclosExamen, setCiclo } = usePromediosResultadosIngles();

    return (
        <Card>
            <Toaster/>


            <p>Filtrar por año:</p>
            <Select
                size="large"
                style={{
                    width: 200,
                    marginBottom: 20
                }}
                onChange={ setCiclo }
                defaultValue={ ciclo }
            >
                { ciclosExamen.map((e, i) =>{
                    return (
                        <Select.Option key={ i } value={ e.ciclo_examen }>
                            { e.ciclo_examen }
                        </Select.Option>
                    )}) }
            </Select>

            <List
                loading={loading}
                size="large"
                header={
                    <div className='ta-center'><b>Promedios de resultados por carrera</b></div>
                }
                dataSource={carreras}
                renderItem={item => {
                    return (
                        <List.Item>
                            <Link className='link-carrera' target='_blank' onClick={() => promediosAspirantesInglesPorCarrera(item.pk_carrera, item.nom_carrera)} >
                                {item.nom_carrera}
                            </Link>
                        </List.Item>
                    )
                }}
            />


            <br/>
            <br />


            <Button type='primary' onClick={() => promediosTodasCarreras()}> Promedios de todas las carreras</Button>


            <br/>
            <br />


            <Button type='primary' onClick={() => promediosAspirantesIngles()}> Promedios de todos los aspirantes</Button>


        </Card>
    );


}

export default PromediosResultadosIngles;
